import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { CERTIFICATIONS } from "../../data/content";

export const Quality = () => {
  // Duplicate so the marquee loops seamlessly
  const items = [...CERTIFICATIONS, ...CERTIFICATIONS];

  return (
    <section
      id="quality"
      data-testid="quality-section"
      className="scroll-mt-nav py-24 md:py-32 bg-white border-t border-ink/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-14 md:mb-20">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-7">
            <div className="overline text-forest-accent mb-4">/ 05 — Quality & Compliance</div>
            <h2
              className="font-display font-bold leading-[1.02] tracking-tight text-ink text-balance"
              style={{ fontSize: "clamp(2rem, 5vw, 4rem)" }}
            >
              Audited, certified,
              <br />
              independently verified.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-start gap-3 text-ink-soft text-base md:text-lg leading-relaxed">
              <ShieldCheck className="w-5 h-5 text-forest-accent shrink-0 mt-1" strokeWidth={1.5} />
              <p>
                Each Milestone facility operates under documented standards for
                food safety, traceability and specialty-chemical quality
                management. Certificates and audit reports available on
                request.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div
        className="relative border-y border-ink/10 bg-bone"
        data-testid="certifications-marquee"
        aria-label="Certifications"
      >
        <div className="overflow-hidden py-8 md:py-12">
          <motion.div
            className="marquee-track gap-12 md:gap-20"
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 85, ease: "linear", repeat: Infinity }}
          >
            {items.map((c, i) => (
              <div
                key={`${c}-${i}`}
                className="flex items-center gap-12 md:gap-20 shrink-0"
              >
                <span className="font-display font-medium tracking-tight text-ink/85 text-3xl md:text-5xl whitespace-nowrap">
                  {c}
                </span>
                <span className="w-2 h-2 rounded-full bg-amber-accent shrink-0" />
              </div>
            ))}
          </motion.div>
        </div>
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-bone to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-bone to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
        {[
          {
            k: "QC Laboratory",
            v: "Our in-house laboratory runs HPLC, GC and Karl-Fischer on every production batch. Nothing ships without passing numbers.",
          },
          {
            k: "Traceable Feedstock",
            v: "Non-GMO declarations, supplier audits and chain-of-custody documentation for natural lines.",
          },
          {
            k: "Regulatory Files",
            v: "Product specifications, technical data sheets (TDS) and safety data sheets (SDS) maintained per product. Custom CoA on request.",
          },
        ].map((b, i) => (
          <div
            key={b.k}
            data-testid={`quality-block-${i}`}
            className="border-t border-ink pt-5"
          >
            <div className="overline text-amber-accent mb-2">0{i + 1}</div>
            <div className="font-display font-medium text-ink text-xl leading-tight mb-2">
              {b.k}
            </div>
            <p className="text-ink-soft text-sm leading-relaxed">{b.v}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
